import { apiSlice } from "../../apiSlice/apiSlice";

export const globalSearchApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    globalSearch: builder.query({
      query: (arg) => {
        if (typeof arg === "string") {
          return { url: `global-search?key=${encodeURIComponent(arg)}` };
        }
        const { key, type, field } = arg;
        let url = `global-search?key=${encodeURIComponent(key)}`;
        if (type && type !== "all") {
          url += `&type=${encodeURIComponent(type)}`;
        }
        if (field && field !== "all") {
          url += `&field=${encodeURIComponent(field)}`;
        }
        return { url };
      },
    }),
  }),
});

export const { useGlobalSearchQuery } = globalSearchApi;
